var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.832a2.332 2.332 0 1 1 0-4.664 2.332 2.332 0 0 1 0 4.665z",
    fill: "#FFD300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.83 6.806c-.739-.041-.962-.041-2.83-.041v.012c-1.868 0-2.091.005-2.83.04a3.803 3.803 0 0 0-1.3.242A2.326 2.326 0 0 0 7.56 8.37a3.803 3.803 0 0 0-.241 1.3c-.042.738-.042.961-.042 2.83 0 1.867.006 2.09.042 2.829.004.444.085.883.24 1.3a2.326 2.326 0 0 0 1.313 1.329c.416.156.855.237 1.3.241.738.041.958.041 2.829.041 1.87 0 2.091-.006 2.83-.04a3.803 3.803 0 0 0 1.3-.242 2.327 2.327 0 0 0 1.326-1.327 3.8 3.8 0 0 0 .241-1.3c.041-.738.041-.961.041-2.829 0-1.868-.006-2.091-.04-2.83a3.803 3.803 0 0 0-.242-1.3 2.326 2.326 0 0 0-1.327-1.326 3.803 3.803 0 0 0-1.3-.241zM13 8.906a3.594 3.594 0 1 0 0 7.189 3.594 3.594 0 0 0 0-7.189zm4.576-.141a.841.841 0 1 1-1.682 0 .841.841 0 0 1 1.682 0z",
    fill: "#FFD300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5 12.5C25.5 19.404 19.904 25 13 25S.5 19.404.5 12.5 6.096 0 13 0s12.5 5.596 12.5 12.5zM10.115 5.556c.747-.041.985-.041 2.885-.041l.027-.027c1.9 0 2.138.01 2.885.041a5.145 5.145 0 0 1 1.7.327 3.56 3.56 0 0 1 2.059 2.059c.204.544.314 1.119.326 1.7.041.747.041.985.041 2.885s-.009 2.138-.04 2.885a5.144 5.144 0 0 1-.327 1.7 3.558 3.558 0 0 1-2.06 2.06 5.143 5.143 0 0 1-1.7.326c-.746.04-.984.04-2.884.04s-2.139-.008-2.886-.04a5.143 5.143 0 0 1-1.7-.327 3.558 3.558 0 0 1-2.059-2.059c-.21-.534-.33-1.1-.353-1.673-.04-.747-.04-.986-.04-2.886 0-1.9.008-2.138.04-2.885a5.144 5.144 0 0 1 .327-1.7 3.559 3.559 0 0 1 2.059-2.059 5.144 5.144 0 0 1 1.7-.326z",
    fill: "#FFD300"
  })));
};

export default SvgInstagram;